module.exports = __webpack_public_path__ + "static/media/MARC2024.d0cb1ced.pdf";